import React, { useState, useEffect } from "react";
import Header from "../../../../Components/Header";
import Sidebar from "../../../../Components/Sidebar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { getDocument, updateDocument, addDocument, getAllDocuments } from "../../../../firebase/dbService";

const HeroConfiguration = () => {
  const [loading, setLoading] = useState(false);
  const [configExists, setConfigExists] = useState(false);
  const [configId, setConfigId] = useState(null);
  
  // Modal states
  const [showHeroContentModal, setShowHeroContentModal] = useState(false);
  const [showFeatureCardsModal, setShowFeatureCardsModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [showFloatingElementsModal, setShowFloatingElementsModal] = useState(false);

  const [formData, setFormData] = useState({
    // Hero Content Fields
    heroBadgeText: "Welcome to Pambazuka Events",
    heroMainTitle: "Creating Memorable",
    heroTitleAccent: "Experiences",
    heroParagraph: "Join our vibrant community and discover extraordinary events that bring people together, inspire connections, and create lasting memories.",
    primaryButtonText: "Explore Events",
    primaryButtonLink: "",
    secondaryButtonText: "Watch Story",
    youtubeLink: "",
    scrollText: "Scroll to explore",

    // Feature Cards
    featureCard1Icon: "fas fa-calendar-alt",
    featureCard1Title: "Events",
    featureCard1Description: "Professional organization",
    featureCard2Icon: "fas fa-users",
    featureCard2Title: "Community",
    featureCard2Description: "Connect with others",
    featureCard3Icon: "fas fa-star",
    featureCard3Title: "Quality",
    featureCard3Description: "Premium experiences",

    // Statistics
    stat1Number: "500+",
    stat1Label: "Events Hosted",
    stat2Number: "10K+",
    stat2Label: "Happy Attendees",
    stat3Number: "5★",
    stat3Label: "Rating",

    // Floating Elements
    floatingElement1Icon: "fas fa-calendar-alt",
    floatingElement2Icon: "fas fa-users",
    floatingElement3Icon: "fas fa-star",
  });

  useEffect(() => {
    fetchHeroConfig();
  }, []);

  const fetchHeroConfig = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getAllDocuments('heroConfig');
      
      if (!querySnapshot.empty) {
        const configDoc = querySnapshot.docs[0];
        const data = configDoc.data();
        setConfigExists(true);
        setConfigId(configDoc.id);
        
        setFormData({
          heroBadgeText: data.heroBadgeText || "Welcome to Pambazuka Events",
          heroMainTitle: data.heroMainTitle || "Creating Memorable",
          heroTitleAccent: data.heroTitleAccent || "Experiences",
          heroParagraph: data.heroParagraph || "Join our vibrant community and discover extraordinary events that bring people together, inspire connections, and create lasting memories.",
          primaryButtonText: data.primaryButtonText || "Explore Events",
          primaryButtonLink: data.primaryButtonLink || "",
          secondaryButtonText: data.secondaryButtonText || "Watch Story",
          youtubeLink: data.youtubeLink || "",
          scrollText: data.scrollText || "Scroll to explore",
          featureCard1Icon: data.featureCard1Icon || "fas fa-calendar-alt",
          featureCard1Title: data.featureCard1Title || "Events",
          featureCard1Description: data.featureCard1Description || "Professional organization",
          featureCard2Icon: data.featureCard2Icon || "fas fa-users",
          featureCard2Title: data.featureCard2Title || "Community",
          featureCard2Description: data.featureCard2Description || "Connect with others",
          featureCard3Icon: data.featureCard3Icon || "fas fa-star",
          featureCard3Title: data.featureCard3Title || "Quality",
          featureCard3Description: data.featureCard3Description || "Premium experiences",
          stat1Number: data.stat1Number || "500+",
          stat1Label: data.stat1Label || "Events Hosted",
          stat2Number: data.stat2Number || "10K+",
          stat2Label: data.stat2Label || "Happy Attendees",
          stat3Number: data.stat3Number || "5★",
          stat3Label: data.stat3Label || "Rating",
          floatingElement1Icon: data.floatingElement1Icon || "fas fa-calendar-alt",
          floatingElement2Icon: data.floatingElement2Icon || "fas fa-users",
          floatingElement3Icon: data.floatingElement3Icon || "fas fa-star",
        });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching hero config:", error);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      
      if (configExists && configId) {
        await updateDocument('heroConfig', configId, formData);
        toast.success("Hero configuration updated successfully!", { autoClose: 2000 });
      } else {
        await addDocument('heroConfig', formData);
        toast.success("Hero configuration created successfully!", { autoClose: 2000 });
        setConfigExists(true);
      }
      
      await fetchHeroConfig();
    } catch (error) {
      toast.error("Error saving configuration: " + error.message, { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar
        id="menu-item4"
        id1="menu-items4"
        activeClassName="heroconfig"
      />
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Hero Section</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Hero Configuration</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>Hero Section Global Configuration</h4>
                        <p className="text-muted">Configure global elements that appear on all hero slides</p>
                      </div>
                    </div>

                    {/* Configuration Buttons */}
                    <div className="col-12 col-md-6 col-xl-3">
                      <button
                        type="button"
                        className="btn btn-info w-100 mb-3"
                        onClick={() => setShowHeroContentModal(true)}
                        disabled={loading}
                      >
                        <i className="fas fa-edit me-2"></i>Hero Content
                      </button>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <button
                        type="button"
                        className="btn btn-success w-100 mb-3"
                        onClick={() => setShowFeatureCardsModal(true)}
                        disabled={loading}
                      >
                        <i className="fas fa-th-large me-2"></i>Feature Cards
                      </button>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <button
                        type="button"
                        className="btn btn-warning w-100 mb-3"
                        onClick={() => setShowStatsModal(true)}
                        disabled={loading}
                      >
                        <i className="fas fa-chart-line me-2"></i>Statistics
                      </button>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <button
                        type="button"
                        className="btn btn-secondary w-100 mb-3"
                        onClick={() => setShowFloatingElementsModal(true)}
                        disabled={loading}
                      >
                        <i className="fas fa-magic me-2"></i>Floating Elements
                      </button>
                    </div>

                    {/* Save Button */}
                    <div className="col-12">
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSave}
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save Configuration"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Content Modal */}
      {showHeroContentModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Hero Content Configuration</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowHeroContentModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Hero Badge Text</label>
                      <input
                        className="form-control"
                        type="text"
                        name="heroBadgeText"
                        value={formData.heroBadgeText}
                        onChange={handleChange}
                        placeholder="Welcome to Pambazuka Events"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Hero Main Title</label>
                      <input
                        className="form-control"
                        type="text"
                        name="heroMainTitle"
                        value={formData.heroMainTitle}
                        onChange={handleChange}
                        placeholder="Creating Memorable"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Hero Title Accent</label>
                      <input
                        className="form-control"
                        type="text"
                        name="heroTitleAccent"
                        value={formData.heroTitleAccent}
                        onChange={handleChange}
                        placeholder="Experiences"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Scroll Text</label>
                      <input
                        className="form-control"
                        type="text"
                        name="scrollText"
                        value={formData.scrollText}
                        onChange={handleChange}
                        placeholder="Scroll to explore"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group local-forms">
                      <label>Hero Paragraph</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="heroParagraph"
                        value={formData.heroParagraph}
                        onChange={handleChange}
                        placeholder="Join our vibrant community..."
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Primary Button Text</label>
                      <input
                        className="form-control"
                        type="text"
                        name="primaryButtonText"
                        value={formData.primaryButtonText}
                        onChange={handleChange}
                        placeholder="Explore Events"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Primary Button Link</label>
                      <input
                        className="form-control"
                        type="url"
                        name="primaryButtonLink"
                        value={formData.primaryButtonLink}
                        onChange={handleChange}
                        placeholder="https://example.com/events"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Secondary Button Text</label>
                      <input
                        className="form-control"
                        type="text"
                        name="secondaryButtonText"
                        value={formData.secondaryButtonText}
                        onChange={handleChange}
                        placeholder="Watch Story"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>YouTube Link</label>
                      <input
                        className="form-control"
                        type="url"
                        name="youtubeLink"
                        value={formData.youtubeLink}
                        onChange={handleChange}
                        placeholder="https://youtube.com/watch?v=..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowHeroContentModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Feature Cards Modal */}
      {showFeatureCardsModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Feature Cards Configuration</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFeatureCardsModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <h6>Feature Card 1</h6>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Icon Class</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard1Icon"
                        value={formData.featureCard1Icon}
                        onChange={handleChange}
                        placeholder="fas fa-calendar-alt"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Title</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard1Title"
                        value={formData.featureCard1Title}
                        onChange={handleChange}
                        placeholder="Events"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Description</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard1Description"
                        value={formData.featureCard1Description}
                        onChange={handleChange}
                        placeholder="Professional organization"
                      />
                    </div>
                  </div>
                  
                  <div className="col-12">
                    <h6>Feature Card 2</h6>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Icon Class</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard2Icon"
                        value={formData.featureCard2Icon}
                        onChange={handleChange}
                        placeholder="fas fa-users"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Title</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard2Title"
                        value={formData.featureCard2Title}
                        onChange={handleChange}
                        placeholder="Community"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Description</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard2Description"
                        value={formData.featureCard2Description}
                        onChange={handleChange}
                        placeholder="Connect with others"
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <h6>Feature Card 3</h6>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Icon Class</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard3Icon"
                        value={formData.featureCard3Icon}
                        onChange={handleChange}
                        placeholder="fas fa-star"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Title</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard3Title"
                        value={formData.featureCard3Title}
                        onChange={handleChange}
                        placeholder="Quality"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group local-forms">
                      <label>Description</label>
                      <input
                        className="form-control"
                        type="text"
                        name="featureCard3Description"
                        value={formData.featureCard3Description}
                        onChange={handleChange}
                        placeholder="Premium experiences"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowFeatureCardsModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Statistics Modal */}
      {showStatsModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Statistics Configuration</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowStatsModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Stat 1 Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name="stat1Number"
                        value={formData.stat1Number}
                        onChange={handleChange}
                        placeholder="500+"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Stat 1 Label</label>
                      <input
                        className="form-control"
                        type="text"
                        name="stat1Label"
                        value={formData.stat1Label}
                        onChange={handleChange}
                        placeholder="Events Hosted"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Stat 2 Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name="stat2Number"
                        value={formData.stat2Number}
                        onChange={handleChange}
                        placeholder="10K+"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Stat 2 Label</label>
                      <input
                        className="form-control"
                        type="text"
                        name="stat2Label"
                        value={formData.stat2Label}
                        onChange={handleChange}
                        placeholder="Happy Attendees"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Stat 3 Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name="stat3Number"
                        value={formData.stat3Number}
                        onChange={handleChange}
                        placeholder="5★"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group local-forms">
                      <label>Stat 3 Label</label>
                      <input
                        className="form-control"
                        type="text"
                        name="stat3Label"
                        value={formData.stat3Label}
                        onChange={handleChange}
                        placeholder="Rating"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowStatsModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Floating Elements Modal */}
      {showFloatingElementsModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Floating Elements Configuration</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFloatingElementsModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group local-forms">
                      <label>Floating Element 1 Icon</label>
                      <input
                        className="form-control"
                        type="text"
                        name="floatingElement1Icon"
                        value={formData.floatingElement1Icon}
                        onChange={handleChange}
                        placeholder="fas fa-calendar-alt"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group local-forms">
                      <label>Floating Element 2 Icon</label>
                      <input
                        className="form-control"
                        type="text"
                        name="floatingElement2Icon"
                        value={formData.floatingElement2Icon}
                        onChange={handleChange}
                        placeholder="fas fa-users"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group local-forms">
                      <label>Floating Element 3 Icon</label>
                      <input
                        className="form-control"
                        type="text"
                        name="floatingElement3Icon"
                        value={formData.floatingElement3Icon}
                        onChange={handleChange}
                        placeholder="fas fa-star"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowFloatingElementsModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default HeroConfiguration;